import { auth } from '../firebase/config';

/**
 * Resolves a fresh Firebase ID token, waiting for auth state to rehydrate if
 * needed. `auth.currentUser` is null for a brief window after a hard page
 * load / full navigation (Firebase Auth restores the persisted session
 * asynchronously) — fetching immediately on mount in that window silently
 * returns null and any calling code that just bails out on that looks like
 * "no data" rather than "not ready yet". Mirrors the same
 * currentUser-then-onAuthStateChanged-with-timeout pattern already used in
 * PropertyDetailPage.js.
 */
export function getFirebaseToken() {
  return new Promise((resolve, reject) => {
    if (auth.currentUser) {
      auth.currentUser.getIdToken().then(resolve).catch(reject);
      return;
    }
    const timeoutId = setTimeout(() => {
      unsubscribe();
      reject(new Error('Firebase auth timeout'));
    }, 10000);
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      clearTimeout(timeoutId);
      unsubscribe();
      if (user) {
        try {
          resolve(await user.getIdToken());
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error('No authenticated user'));
      }
    });
  });
}
